<template>
  <div>
    <PricingFilterToolbar
      :search-term="searchTerm"
      :expired-filter="expiredFilter"
      search-placeholder="Search by Description..."
      @search-change="searchTerm = $event"
      @expired-filter-change="expiredFilter = $event"
    >
      <template v-slot:actions>
        <button v-if="userEditRight" @click="addNewPackagePrice()" type="button" class="btn btn-info mr-3 mb-2">Add New Price Package</button>
      </template>
    </PricingFilterToolbar>
    <div class="table-responsive table-bordered" v-if="packages.length > 0">
      <table class="table pricing-table">
        <thead>
          <tr class="text-nowrap">
            <th class="table-font-size pricing-column-description">Description</th>
            <th class="table-font-size pricing-column-size">Size</th>
            <th class="table-font-size pricing-column-price">NRC (excl. VAT)</th>
            <th class="table-font-size pricing-column-price">MRC (excl. VAT)</th>
            <th class="table-font-size pricing-column-price">MRC (incl. VAT)</th>
            <th class="table-font-size pricing-column-status">Expired</th>
            <th class="table-font-size pricing-column-services">Services</th>
            <th class="table-font-size pricing-column-id">#</th>
            <th class="table-font-size pricing-column-actions">Commands</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            :class="pricePackage.expired ? 'bg-primary' : ''" 
            v-for="(pricePackage, rowIndex) in packages"
            :key="rowIndex"
          >
            <td>
                <strong>
                  <span class="font-size">{{ pricePackage.description }}</span>
                </strong>
            </td>
            <td><span class="font-size">{{ pricePackage.size > 0 ? pricePackage.size : 'Uncapped' }} {{ pricePackage.size > 0 ? 'GB' : ''}}</span></td>
            <td>
              <span class="font-size">
                {{
                  getSetupFee(pricePackage.ltebundleprices, period)
                }}
              </span>
            </td>
            <td>
              <span class="font-size">
              {{getPrice(pricePackage.ltebundleprices, period)}}
              </span>
              <span v-if="userEditRight" style="cursor: pointer" v-tooltip="'Edit Row Price'" @click="openPriceModal(pricePackage)"
                class="pull-right">
                <em class="fa fa-edit fa-fw text-green"></em>
              </span>
            </td>
            <td>
              <span class="font-size">{{getPrice(pricePackage.ltebundleprices, period, true)}}</span>                
            </td>
            <td class="text-center">
              <span
                class="badge"
                :class="pricePackage.expired ? 'badge-warning' : 'badge-green'"
                >{{ pricePackage.expired }}
              </span>
            </td>
            <td class="text-nowrap text-center">
                <strong>
                  <span class="font-size">{{ servicesAmount(pricePackage) }}</span>
                </strong>
            </td>
            <td class="text-nowrap">
              <span>{{pricePackage.lteBundleNumber}}</span>
            </td>
            <td class="text-center">
              <button
                v-if="userEditRight"
                v-tooltip="'Edit Package'"
                @click="editPackagePrice(pricePackage)"
                type="button"
                class="btn btn-sm btn-info m-1"
              >
                <em class="fa fa-edit fa-fw"></em>
              </button>
              <button
                v-if="userEditRight"
                v-tooltip="'Delete Package'"
                @click="deletePackagePrice(pricePackage)"
                type="button"
                class="btn btn-sm btn-primary"
              >
                <em class="fa fa-trash fa-fw"></em>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="alert alert-info col-sm-12" v-else>
      <strong>No price packages to display</strong>
    </div>
    <AddPriceModal 
      ref="addPriceModal" 
      :row-price="rowPrice" 
      :new-price="newPrice" 
      :package-description="packageDescription"
      @addPrice="addPrice"
      @pricesAdded="getLtePackages()" 
    />
    <LtePriceModal 
      ref="modifyPackage" 
      :pricePackage="newPricePackage" 
      :availableLteProducts="availableProducts"
      :supplier="productSupplier" 
      @save-price="saveNewPricePackage" 
      @update-price="updatePricePackage" 
    />
  </div>
</template>

<script>
  import AddPriceModal from '@/components/Admin/Modals/AddPriceModal'
  import LtePriceModal from '@/components/Admin/Modals/LtePriceModal'
  import PricingFilterToolbar from '@/components/Admin/PricingFilterToolbar'
  import PriceFunctions from '@/components/Admin/PriceFunctions'

  export default {
    extends: PriceFunctions,
    props: {
      productNumber: {
        type: Number,
        required: true
      },
      productSupplier: {
        type: String,
        required: true
      },
      userEditRight: {
        type: Boolean,
        required: true
      },
    },
    components: {
      AddPriceModal,
      LtePriceModal,
      PricingFilterToolbar
    },
    data() {
      return {
        period: this.getCurrentPeriod(),
        newPrice: {},
        newPricePackage: {},
        mwebpackages: [],
        rowPrice: [],
        availableProducts: [],
        expiredFilter: 'false',
        searchTerm: '',
        getPackageSaleAmounts: true,
        packageDescription: '',
      }
    },
    mounted() {
      this.getLtePackages();
    },
    watch: {
      searchTerm(newVal, oldVal) {      
        if (oldVal !== newVal) {
          this.getPackageSaleAmounts = false;
        } 
      },
      expiredFilter(newVal, oldVal) {
        if (newVal !== oldVal && !this.getPackageSaleAmounts) {
          this.getPackageSaleAmounts = true;
        }
      }
    },
    computed: {
      packages() {  
        if (this.expiredFilter === 'true') {
          this.filteredPackages = this.mwebpackages.filter(p => p.expired === true);
        } else if (this.expiredFilter === 'both') {
          this.filteredPackages = this.mwebpackages;
        } else {
          this.filteredPackages = this.mwebpackages.filter(p => p.expired === false);
        }
        this.searchPackages(this.searchTerm); 
        this.getServiceAmounts(this.filteredPackages);        
        return this.filteredPackages;
      },
    },
    methods: {
      getLtePackages() {
        this.$http.get(this.$config.aimsAPI + 'pricing/ltebundles/' + this.productNumber)
          .then(response => {
              this.mwebpackages = response.data;
              this.$http.get(this.$config.aimsAPI + 'mweb/mtn/availableproducts')
                .then(response => {
                    this.availableProducts = response.data;
                  },
                  error => {
                    this.showError('Error fetching Available LTE Products', error)
                    console.error(error);
                  });

            },
            error => {
              this.showError('Error fetching LTE Bundles', error)
              console.error(error);
            });
      },
      addNewPackagePrice() {
        this.newPricePackage = this.deepCopyObject({
          productNumber: this.productNumber,
          class: 'za.co.adept.aims.lte.LteBundle'
        });
        this.$refs.modifyPackage.open();
      },
      editPackagePrice(pricePackage) {
        this.newPricePackage = this.deepCopyObject(pricePackage);
        this.$refs.modifyPackage.open();
      },
      openPriceModal(pPackage) {
        this.rowPrice = this.deepCopyObject(pPackage.ltebundleprices);
        this.packageDescription = pPackage.description || '';
        this.newPrice = this.deepCopyObject({
          lteBundleNumber: pPackage.lteBundleNumber,
          class: pPackage.class + 'Price',
          validFrom: 0,
          validUntil: 0
        });
        this.newPrice.setupfee = 0.00,
        this.$refs.addPriceModal.open();
      },
      addPrice(newPrice) {
        this.rowPrice.forEach(price => {
          if (price.validUntil == 0) {
            if (newPrice.validFrom % 100 > 1) {
              price.validUntil = newPrice.validFrom - 1;
            } else {
              price.validUntil = (newPrice.validFrom - 100) + 11;
            }
          }
        });
        this.rowPrice.push(newPrice);
        this.newPrice = this.deepCopyObject({
          lteBundleNumber: newPrice.lteBundleNumber,
          class: newPrice.class,
          validFrom: 0,
          validUntil: 0,
          setupfee: 0.00
        });
      },
      updatePricePackage(pricePackage) {
        this.saveData(pricePackage).then(response => {
            this.showSuccess('Updated Row Successfully');
            this.getLtePackages();
          },
          error => {
            this.showError("Error Saving LTE Price Package", error);
            console.error(error);
          })
      },
      saveNewPricePackage(newPackage) {
        this.$http.post(this.$config.aimsAPI + 'pricing/pricepackages/save', newPackage)
          .then(response => {
            this.showSuccess('Updated Row Successfully');
            response.data.ltebundleprices = [];
            this.openPriceModal(response.data);
          }, error => {
            this.showError("Error Saving Pricing", error);
            console.error(error);
          })
      },
      deletePackagePrice(pricePackage) {
        this.$swal({
          title: 'Are you sure you want to delete LTE price package?',
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.value) {
            this.$http.delete(this.$config.aimsAPI + 'pricing/pricepackages/' + pricePackage.objKey +
                '?objClassName=' + pricePackage.class)
              .then(response => {
                this.showSuccess('Successfully deleted LTE price package');
                this.getLteBundles();
              }, error => {
                this.showError("Error Deleting LTE Pricing Package", error);
              })
          }
        });
      },
      getServiceAmounts: function(data) {     
        const hostUrl = this.$config.aimsAPI;  
        if (!this.searchTerm || this.getPackageSaleAmounts) {
          this.$http.post(`${hostUrl}pricing/linkedservices/amount`, data).then(
            (response) => {
              this.packageSalesData = response.data;      
            },
            (error) => {
              this.showError("Error fetching package sales data", error);
              console.error(error);
            }
          );        
        }
      },
      servicesAmount: function(packageData) {
        let saleAmount;        
        this.packageSalesData.filter(data => {
          if (data.lteBundleNumber === packageData.lteBundleNumber) {
            saleAmount = data.sales;
          }
        });   
        return saleAmount;
      },
      searchPackages: function(searchTerm) {
        if (searchTerm) {
            this.filteredPackages = this.filteredPackages.filter(p => p.description.toLowerCase().includes(searchTerm.toLowerCase()));
        }
      }
    },
  }

</script>
<style scoped>
th.table-font-size {
  font-size: .95rem;
}
th.table-header-width-1 {
  width: 10px;
}
th.table-header-width-2 {
  width: 20px;
}
th.table-header-width-3 {
  width: 50px;
}
th.table-header-width-4 {
  width: 60px;
}
th.table-header-width-5 {
  width: 95px;
}
th.table-header-width-6 {
  width: 200px;
}

.font-size {
  font-size: .9rem;
}
</style>